<template>
  <input
    class="form-control"
    v-model="fields.value"
    v-money="moneySettings"
    :disabled="disabled"
    :placeholder="placeholder"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'InputMoney',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      default: 'R$ 0,00'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    decimal: {
      type: String,
      required: false,
      default: ',',
    },
    thousands: {
      type: String,
      required: false,
      default: '.',
    },
    prefix: {
      type: String,
      required: false,
      default: 'R$',
    },
    suffix: {
      type: String,
      required: false,
      default: '',
    },
    precision: {
      type: Number,
      required: false,
      default: 2,
    },
    masked: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    moneySettings() {
      return {
        decimal: this.decimal,
        thousands: this.thousands,
        prefix: this.prefix,
        suffix: this.suffix,
        precision: this.precision,
        masked: this.masked,
      };
    },
  },
  watch: {
    'value': function () {
      this.fields.value = this.value;
    },
    'fields.value': function () {
      this.$emit('update:value', this.fields.value);
      this.removeNegative();
    },
  },
  mounted() {
    this.fields.value = this.value;
  },
  data() {
    return {
      fields: {
        value: 0,
      },
    };
  },
  methods: {
    removeNegative(){
      this.fields.value = this.fields.value.replace('-', '');
    }
  }
};
</script>